import { useMemo } from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Tooltip } from "@mui/material";

import { ApiHotelItem } from "@/api/hotel";
import { bankBgColor } from "@/constants/config";
import { HOTEL_IMG, HOTEL_NAME } from "@/constants/hotels";
import { BANK_NAME_MAP } from "@/constants/programs";
import { bankCardSmallImg } from "@/constants/image-map";
import useThemeData from "@/hooks/useThemeData";

import { getBanksByHotelName } from "../../utils";

interface BanksProps {
  data: ApiHotelItem;
}
const SummaryOptionsCard = (props: BanksProps) => {
  const { data } = props;
  const theme = useThemeData();

  const options = useMemo(() => {
    return getBanksByHotelName(data.brand);
  }, [data]);

  return (
    <div className="flex items-center">
      {options.length > 0 ? (
        <Box
          className="flex flex-wrap rounded-[6px] px-[2px] py-[5px] items-center"
          sx={{
            backgroundColor: theme.isDarkMode ? bankBgColor : "#EEEEEE",
          }}
        >
          {options.map((ele, i) => {
            return (
              <Tooltip title={<div className="flex items-center gap-2"><img src={ele.img} className="w-10 h-10 object-contain" />{BANK_NAME_MAP[ele.name]}</div>} placement="top" arrow>
                <div key={i} className={"relative px-[3px] text-[0px] h-[35px] w-[35px]"}>
                  <img src={bankCardSmallImg[ele.name]} className={`w-full h-full object-contain p-[1px]`} />
                </div>
              </Tooltip>
            );
          })}
        </Box>
      ) : (
        <div />
      )}

      {options && options.length > 0 ? (
        <ArrowForwardIcon
          className="!text-[12px]"
          sx={{ color: (theme) => theme.palette.text.secondary }}
        />
      ) : null}

<Tooltip title={<div className="flex items-center gap-2"><img src={HOTEL_IMG[data.brand]} className="w-10 h-10 object-contain" />{HOTEL_NAME[data.brand] || data.brand}</div>} placement="top" arrow>
        <div
          className={"h-[40px] overflow-hidden w-[80px] p-[5px] rounded-[5px]"}
          style={{ backgroundColor: theme.isDarkMode ? bankBgColor : "#EEEEEE" }}
        >
          <img className="object-contain w-full h-full" src={HOTEL_IMG[data.brand]} />
        </div>
      </Tooltip>
    </div>
  );
};
export default SummaryOptionsCard;
